// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniMyAccountStyles } from "@synd/App/Components/MiniMyAccount/MiniMyAccount";
import { HEADER_HEIGHT_CSS_VAR } from "@synd/XDL/constants";
import HeaderUtilitySwitchAccount from "@synd/XDL/Icons/HeaderUtilitySwitchAccount";
import LinkSignOutBase from "@synd/XDL/Icons/LinkSignOutBase";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, styledScrollbar } from "@synd/XDL/Utilities";
import { css } from "styled-components";

miniMyAccountStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        max-height: calc(100vh - var(${HEADER_HEIGHT_CSS_VAR}) + 30px);
        ${styledScrollbar()}
    `,
};

miniMyAccountStyles.linksContainer = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

miniMyAccountStyles.linksSection = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px 20px;
        justify-items: start;
    `,
};

miniMyAccountStyles.link = {
    color: "text.main",
    mergeCss: true,
    typographyProps: {
        size: fontConfig.xSmallSingleLine.size,
        weight: fontConfig.weight.medium,
        css: css`
            line-height: ${fontConfig.xSmallSingleLine.lineHeight};
        `,
    },
};

miniMyAccountStyles.infoSections = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    `,
};

miniMyAccountStyles.infoSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};
miniMyAccountStyles.sectionTitle = {
    variant: "h6",
    forwardAs: "p",
};

miniMyAccountStyles.infoSectionTitle = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.semiBold,
};

miniMyAccountStyles.addressInfo = {
    address1Text: {
        ...fontConfig.xSmall,
    },
    address2Text: {
        ...fontConfig.xSmall,
    },
    cityStatePostalCodeText: {
        ...fontConfig.xSmall,
    },
    cityText: {
        ...fontConfig.xSmall,
    },
    postalCodeText: {
        ...fontConfig.xSmall,
    },
    stateText: {
        ...fontConfig.xSmall,
    },
};

miniMyAccountStyles.actionsContainer = {
    css: css`
        display: flex;
        border-top: 1px solid ${color("common.border")};
        padding: 16px;
        margin-top: 16px;
        align-items: center;
    `,
};

miniMyAccountStyles.signOutButton = {
    variant: "link" as any,
    sizeVariant: "small",
    icon: {
        src: LinkSignOutBase,
        position: "left",
    },
    css: css`
        margin-left: auto;
    `,
};

miniMyAccountStyles.changeShiptoLink = {
    variant: "link" as any,
    sizeVariant: "small",
    icon: {
        src: HeaderUtilitySwitchAccount,
        position: "left",
    },
};

miniMyAccountStyles.infoLink = {
    mergeCss: true,
    typographyProps: {
        size: fontConfig.xSmallSingleLine.size,
        css: css`
            line-height: ${fontConfig.xSmallSingleLine.lineHeight};
        `,
    },
};
